module.exports = __webpack_public_path__ + "img/area_18.7aaccfe0.svg";